<template>
  <div class="bg-white rounded-[24px] border border-[#1c4848]/5 shadow-sm flex flex-col sm:flex-row overflow-hidden h-full">
    <div class="w-full sm:w-[200px] shrink-0 min-h-[240px] sm:min-h-full bg-[#1c4848]/10 animate-pulse" />
    <div class="flex-1 flex flex-col p-6 min-w-0 gap-3">
      <div class="flex gap-2">
        <span class="h-6 w-16 rounded-lg bg-[#1c4848]/10 animate-pulse" />
        <span class="h-6 w-20 rounded-lg bg-[#1c4848]/10 animate-pulse" />
      </div>
      <div class="h-6 w-2/3 rounded bg-[#1c4848]/15 animate-pulse" />
      <div class="flex gap-2">
        <span class="h-4 w-24 rounded bg-[#1c4848]/10 animate-pulse" />
        <span class="h-4 w-28 rounded bg-[#1c4848]/10 animate-pulse" />
      </div>
      <div class="h-4 w-full rounded bg-[#1c4848]/10 animate-pulse" />
      <div class="h-4 w-full rounded bg-[#1c4848]/10 animate-pulse" />
      <div class="flex gap-2 mt-2">
        <span class="h-6 w-14 rounded-md bg-[#1c4848]/10 animate-pulse" />
        <span class="h-6 w-16 rounded-md bg-[#1c4848]/10 animate-pulse" />
      </div>
      <div class="grid grid-cols-3 gap-2 py-3 border-t border-dashed border-[#1c4848]/10 mt-auto bg-[#fafbfc]/50 rounded-xl px-2">
        <div class="h-8 w-12 rounded bg-[#1c4848]/10 animate-pulse" />
        <div class="h-8 w-10 rounded bg-[#1c4848]/10 animate-pulse" />
        <div class="h-8 w-10 rounded bg-[#1c4848]/10 animate-pulse" />
      </div>
      <div class="flex justify-between mt-4 pt-3 border-t border-[#1c4848]/5">
        <span class="h-4 w-24 rounded bg-[#1c4848]/10 animate-pulse" />
        <span class="h-8 w-24 rounded-lg bg-[#1c4848]/10 animate-pulse" />
      </div>
    </div>
  </div>
</template>

<script setup>
</script>
